export default __webpack_public_path__ + "static/media/moon.04d1a5ab.png";